import { createContext, useContext } from "react";
import type { ComponentType, CSSProperties, ReactNode } from "react";

// Internal navigation links in site-kit components must behave differently
// per host: the public website wants react-router <Link> (SPA navigation),
// while the admin live-preview wants a non-navigating anchor (clicking a link
// inside the preview must not change the admin's route). Rather than hard-wire
// react-router into site-kit, components resolve their link component from this
// context. The default is a plain <a>, so site-kit works even with no provider.
export interface SiteLinkProps {
  to: string;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
}

const DefaultSiteLink: ComponentType<SiteLinkProps> = ({ to, className, style, children }) => (
  <a href={to} className={className} style={style}>
    {children}
  </a>
);

export const SiteLinkContext = createContext<ComponentType<SiteLinkProps>>(DefaultSiteLink);
export const SiteLinkProvider = SiteLinkContext.Provider;

export function useSiteLink(): ComponentType<SiteLinkProps> {
  return useContext(SiteLinkContext);
}
